import { render, staticRenderFns } from "./CartVehicles.vue?vue&type=template&id=0848fdd6"
import script from "./CartVehicles.vue?vue&type=script&lang=js"
export * from "./CartVehicles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CartRemoveButton: require('/app/components/CartRemoveButton.vue').default,CartPanel: require('/app/components/CartPanel.vue').default})
